import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { RosterRunHistoryEntry } from "@app/models/rest/roster/roster-run-history-entry";

@Injectable({
  providedIn: "root"
})
export class RosterRunHistoryEntryRestService extends HateoasResourceOperation<RosterRunHistoryEntry> {
  constructor() {
    super(RosterRunHistoryEntry);
  }
}
